module.exports = __webpack_public_path__ + "img/3_target.fc5f8b2e.jpg";